import { makeStyles } from '@admitkard/ccl';

export default makeStyles((theme) => ({
  blogsHeaderImgContainer:{
    '& *'  : {
      boxSizing: 'border-box',
      margin:'0px',
      padding:'0px',
    },
    backgroundImage:(props:any) => props.imgUrl ? `url(${props.imgUrl}) ` : '#ECDAFF;',
    backgroundPosition: 'top',
    WebkitBackgroundSize: 'cover',
    MozBackgroundSize: 'cover',
    OBackgroundSize: 'cover',
    backgroundSize: 'cover',
    display: '-webkit-box',
    WebkitBoxPack: 'end',
    WebkitJustifyContent: 'flex-end',
    MozBoxPack: 'end',
    MsFlexPack: 'end',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    minHeight: '16.75rem',
    width:'100%',
    position:'relative',
    '@media screen and (min-width: 768px)' : {
      minHeight: '18.8125rem',
      borderRadius: '1.5rem',
    },
  },
  blogsHeaderImgDetails:{
    position: 'absolute',
    bottom:'0px',
    width: '100%',
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 13.91%, #F6F6F6 60.26%)',
    padding:'0px 1rem',
    '@media screen and (min-width: 768px)' : {
      bottom:'0px',
      borderRadius: '1.5rem',
    },
  },
  title:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    textAlign: 'center',
    color: theme.colorPalette.indigo.main,
    marginTop:'4.625rem',
    '@media screen and (min-width: 768px)' : {
      fontSize: '1.5rem',
      lineHeight: '2.25rem',
      marginTop:'5.0625rem',
    },
  },
  subTitle : {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    textAlign: 'center',
    color: theme.colorPalette.indigo.main,
    marginTop:'0.5rem',
    marginBottom: '0.25rem',
    '@media screen and (min-width: 768px)' : {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      marginBottom: '1rem',
    }
  },
}),{name: 'HomeBlog'});
